// extracted by mini-css-extract-plugin
module.exports = {"createProjectDialog":"createProjectDialog--23Ft_","more":"more--2JtIQ"};